// @ts-check
// Cynhyrchwyd y ffeil hon yn awtomatig. PEIDIWCH Â MODIWL
// This file is automatically generated. DO NOT EDIT

export function GoGet(arg1, arg2) {
  return window['go']['main']['App']['GoGet'](arg1, arg2);
}

export function GoPost(arg1, arg2) {
  return window['go']['main']['App']['GoPost'](arg1, arg2);
}

export function Greet(arg1) {
  return window['go']['main']['App']['Greet'](arg1);
}



//////////////////
// WEBPACK FOOTER
// ./wailsjs/go/main/App.js
// module id = null
// module chunks = 